import React from 'react'
import { Box, Drawer } from '@mui/material'
import CrossDialogBtn from 'common/Button/CrossDialogBtn'
import NormalText from 'common/Typography/NormalText'
import { RefundRequestsType } from 'types/api/faber/payment.type'

import FaberViewMoreInformation from './FaberViewMoreInformation'
interface ViewInfoProps {
  paymentRow: RefundRequestsType
  handleClose: () => void
  updateRow: () => void
  dialogOpen: boolean
}

function FaberViewRefundMoreInfo({
  paymentRow,
  handleClose,
  dialogOpen
}: ViewInfoProps) {
  return (
    <Box>
      <React.Fragment>
        <Drawer
          open={dialogOpen}
          onClose={handleClose}
          anchor='right'
          elevation={20}
        >
          <Box
            sx={{
              pt: 2,
              display: 'flex',
              justifyContent: 'space-between',
              mr: 2
            }}
          >
            <NormalText isBold sx={{ fontSize: '1.5em', p: 1 }}>
              View more information
            </NormalText>
            <CrossDialogBtn dialogClose={handleClose} />
          </Box>
          <FaberViewMoreInformation paymentRow={paymentRow} />
        </Drawer>
      </React.Fragment>
    </Box>
  )
}

export default FaberViewRefundMoreInfo
